import { configureStore } from '@reduxjs/toolkit'

export default configureStore({
    reducer: {
        // 필요시 reducer 추가
    }
})